import { AppShell } from "@mantine/core";

import LayoutFooter from "@/components/Layout/LayoutFooter";
import LayoutPromo from "@/components/Layout/LayoutPromo";
import { LAYOUT_NAVBAR_WIDTH_ASIDE } from "@/configs/layout";

import type { PropsWithChildren } from "react";

export const LayoutAside = ({ children }: PropsWithChildren) => {
  return (
    <AppShell
      withBorder={false}
      navbar={{
        width: LAYOUT_NAVBAR_WIDTH_ASIDE,
        breakpoint: "md",
        collapsed: { mobile: true },
      }}
      footer={{
        height: "auto",
        offset: false,
      }}
      padding={{
        base: "xs",
        sm: "lg",
      }}
      layout="alt"
    >
      <AppShell.Navbar>
        <AppShell.Section grow>
          <LayoutPromo />
        </AppShell.Section>
      </AppShell.Navbar>
      <AppShell.Main>{children}</AppShell.Main>
      <AppShell.Footer>
        <LayoutFooter />
      </AppShell.Footer>
    </AppShell>
  );
};

export default LayoutAside;
